import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter as Router, useNavigate } from "react-router-dom";
import { initializeSocket } from "services/socketService";
import "./App.css";
import { CardDetailProvider } from "./Components/CardDetailContext";
import { ContactsDetProvider } from "./Components/ContactsDetContext";
import { CreateCardDetailProvider } from "./Components/CreatecardDetailContext";
import Lightbox from "./Components/Dashboard/LightBox";
import { ProfilesProvider } from "./Components/ProfileDetailContext";
import { QuantityProvider } from "./Components/QuantityContext";
import { UserDetailProvider } from "./Components/UserDetailContext";
import MainContent from "./MainContent";

// Separate component that has access to navigate (must be inside Router)
const AppContent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isVideoCallActive, setIsVideoCallActive] = useState(false);
  const [isLightBoxVisible, setIsLightBoxVisible] = useState(false);
  const [callData, setCallData] = useState(null);
  const deeLinkURLPath = useSelector((state) => state?.onboarding?.deeplinkURL);
  const hasNavigated = useRef(false);
  const isAuth = localStorage.getItem("objectId");

  // console.log("ddddee", deeLinkURLPath);
  useEffect(() => {
    // Navigate only if authenticated, deeplink URL exists, and hasn't navigated yet
    if (isAuth && deeLinkURLPath && typeof deeLinkURLPath === 'string' && deeLinkURLPath.trim() !== '' && !hasNavigated.current) {
      let targetUrl = deeLinkURLPath;

      // If it's still showing as array-like object, reconstruct it
      if (typeof deeLinkURLPath === 'object' && !Array.isArray(deeLinkURLPath)) {
        targetUrl = Object.values(deeLinkURLPath).join('');
      } else if (Array.isArray(deeLinkURLPath)) {
        targetUrl = deeLinkURLPath.join('');
      }

      // Extract the path from the full URL
      let navigateTo = targetUrl;
      try {
        const urlObj = new URL(targetUrl);
        navigateTo = urlObj.pathname + urlObj.search + urlObj.hash;
      } catch (error) {
        // If it's not a valid URL, assume it's already a path
        navigateTo = targetUrl;
      }

      console.log("Navigating to deeplink URL:", navigateTo);
      hasNavigated.current = true;
    }
  }, [isAuth, deeLinkURLPath, navigate, dispatch]);

  useEffect(() => {
    initializeSocket();
  }, []);

  const handleStartVideoCall = (meetingData) => {
    console.log("🚀 App - Starting video call with data:", meetingData);

    if (!meetingData || !meetingData.meetingName) {
      console.error("❌ Invalid meeting data:", meetingData);
      return;
    }
    setCallData(meetingData);
    setIsVideoCallActive(true);
  };

  return (
    <UserDetailProvider>
      <CardDetailProvider>
        <CreateCardDetailProvider>
          <ProfilesProvider>
            <QuantityProvider>
              <ContactsDetProvider>
                <MainContent
                  isVideoCallActive={isVideoCallActive}
                  callData={callData}
                  setIsVideoCallActive={setIsVideoCallActive}
                  onStartVideoCall={handleStartVideoCall}
                  setIsLightBoxVisible={setIsLightBoxVisible}
                  setCallData={setCallData}
                />
                <Lightbox
                  isLightBoxVisible={isLightBoxVisible}
                  setIsLightBoxVisible={setIsLightBoxVisible}
                />
              </ContactsDetProvider>
            </QuantityProvider>
          </ProfilesProvider>
        </CreateCardDetailProvider>
      </CardDetailProvider>
    </UserDetailProvider>
  );
};

// Main App component with Router at the top level
const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
